import type { FormConfig } from '@tencent/wb-ext-form';
import { FormItemName, FormItemLabelName, FormItemType } from '@framework/workbench/drawer/constants';
import { ChartFormItemKey } from '@tencent/chart-drawer-components/lib/schema';
import i18n from '@i18next/i18n';

export const FORM_CONFIGS: FormConfig[] = [
    {
        type: FormItemType.CUSTOM,
        name: ChartFormItemKey.CHART_GLOBAL_SOFT_EDGE,
        content: '',
    },
    {
        type: FormItemType.SLIDER,
        name: ChartFormItemKey.CHART_GLOBAL_SOFT_EDGE_SIZE,
        label: FormItemLabelName.SIZE,
        options: {
            suffix: i18n.t('磅'),
            step: 1,
        },
        defaultValue: 0,
    },
];
